var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.67C6.71 5.67 5.67 6.72 5.67 8C5.67 9.28 6.72 10.33 8 10.33C9.28 10.33 10.33 9.28 10.33 8C10.33 6.72 9.28 5.67 8 5.67ZM15 8C15 7.03 15 6.08 14.95 5.11C14.9 3.99 14.64 2.99 13.82 2.18C13 1.36 12.01 1.1 10.89 1.05C9.92 1 8.97 1 8 1C7.03 1 6.08 1 5.11 1.05C3.99 1.1 2.99 1.36 2.18 2.18C1.36 3 1.1 3.99 1.05 5.11C1 6.08 1 7.03 1 8C1 8.97 1 9.92 1.05 10.89C1.1 12.01 1.36 13.01 2.18 13.82C3 14.64 3.99 14.9 5.11 14.95C6.08 15 7.03 15 8 15C8.97 15 9.92 15 10.89 14.95C12.01 14.9 13.01 14.64 13.82 13.82C14.64 13 14.9 12.01 14.95 10.89C15.01 9.93 15 8.97 15 8ZM8 11.59C6.01 11.59 4.41 9.99 4.41 8C4.41 6.01 6.01 4.41 8 4.41C9.99 4.41 11.59 6.01 11.59 8C11.59 9.99 9.99 11.59 8 11.59ZM11.74 5.1C11.28 5.1 10.9 4.73 10.9 4.26C10.9 3.79 11.27 3.42 11.74 3.42C12.21 3.42 12.58 3.79 12.58 4.26C12.5825 4.36954 12.5625 4.47842 12.5212 4.57992C12.48 4.68141 12.4183 4.77333 12.34 4.85C12.2633 4.92827 12.1714 4.98997 12.0699 5.03125C11.9684 5.07253 11.8595 5.09253 11.75 5.09L11.74 5.1Z",
    fill: "#E6E6E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIg);
export default __webpack_public_path__ + "static/media/ig.3015d76256c0c7f5c2942cd70a818428.svg";
export { ForwardRef as ReactComponent };